import { addActiveState, removeActiveState } from './HandleActiveState'

export const handleClick = (listItems, isScrollingCallback) => {
  listItems.forEach((listItem) => {
    listItem.addEventListener('click', (event) => {
      event.preventDefault()

      // Announce that we're scrolling so other scroll events won't run
      isScrollingCallback(true)

      // Set current item
      removeActiveState(listItems)

      let target = event.currentTarget

      addActiveState(target)

      // Ensure current item is focused (for accessibility)
      setTimeout(() => target.parentElement.focus(), 100)

      // Update browser back button with bookmark
      const bookmark = listItem.dataset.name

      history.pushState(null, null, `#${bookmark}`)

      // Scroll to clicked section
      let scrollTo = document.getElementById(bookmark).offsetTop + 130

      const step = () => {
        window.scrollTo({
          top: scrollTo,
          left: 0,
          behavior: 'smooth',
        })

        // Announce that we're done scrolling
        setTimeout(() => isScrollingCallback(false), 1000)
      }

      window.requestAnimationFrame(step)
    })
  })
}
